/** Companion spotlight / page hints — internal UX, not shown as agent identity. */

export const COMPANION_HIGHLIGHT_EVENT = 'mmec-companion-highlight';
export const COMPANION_HIGHLIGHT_CLEAR_EVENT = 'mmec-companion-highlight-clear';

export type CompanionHighlightDetail = {
  symbol?: string;
  message?: string;
  /** Optional CSS selector; symbol search used when omitted */
  selector?: string;
};

export function applyCompanionHighlight(detail: CompanionHighlightDetail): void {
  window.dispatchEvent(
    new CustomEvent(COMPANION_HIGHLIGHT_EVENT, { detail }),
  );
}

export function clearCompanionHighlights(): void {
  window.dispatchEvent(new CustomEvent(COMPANION_HIGHLIGHT_CLEAR_EVENT));
}
